import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import type {
  CreateAssetPlanFromAssetsInput,
  CreateAssetPlanFromAssetsMutation,
} from '#/graphql/types';
import { createAssetPlanFromAssets } from '#/graphql/mutations';

const q = gql(createAssetPlanFromAssets);

const useCreateAssetPlanFromAssetsMutation = () => {
  const [mutation, result] = useMutation<CreateAssetPlanFromAssetsMutation>(q);

  const createAssetPlanFromAssetsMutation = useCallback(
    async (data: CreateAssetPlanFromAssetsInput) => {
      const response = await mutation({
        variables: {
          data,
        },
      });

      const mutationResult = response.data?.createAssetPlanFromAssets;
      if (mutationResult?.status !== 200) {
        throw new Error(mutationResult?.errors?.join('\n') || 'Create failed');
      }

      return mutationResult.data ?? undefined;
    },
    [mutation],
  );

  return { createAssetPlanFromAssetsMutation, result };
};

export default useCreateAssetPlanFromAssetsMutation;
